
<template>
  <div>
    <base-card :option="cardOption">
      <div slot="cardBody">
        <a :href="`${$sysInfo.apiFpsRemote}/index`" target="_blank">文件预览项目接入说明</a>
        <a-divider />
        <search-form @setSearchCondition="setSearchCondition" @clearSearch="clearSearch"></search-form>
        <!--      操作按钮-->
        <div class="table-operator">
          <a-button style="margin-right: 10px" type="primary" icon="plus" @click="handleAdd">新增</a-button><a-popconfirm
            title="确定要批量删除吗?"
            @confirm="batchDel">
            <a-button icon="delete" >批量删除</a-button>
          </a-popconfirm>
        </div>
        <!--表格-->
        <div class="table">
          <a-table
            :columns="table.columns"
            :rowKey="record => record.id"
            :dataSource="table.data"
            :pagination="pagination"
            :loading="table.loading"
            @change="handleTableChange"
            :rowSelection="rowSelection"
            :scroll="{x:1220}"
          >
            <template slot="actions" slot-scope="text, record">
              <a href="javascript:;" @click="() => handleView(record)">查看</a>
              <a-divider type="vertical" />
              <a href="javascript:;" @click="() => handleEdit(record)">编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm v-if="table.data.length" title="确定要删除吗?" @confirm="() => onDelete(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
          </a-table>
        </div>
      </div>
    </base-card>
    <!--各种弹出组件-->
    <edit-modal ref="editModal" @refreshTable="initTableData"></edit-modal>
    <view-modal ref="viewModal"></view-modal>
  </div>
 </template>

<script>
import { getFpsAppList, deleteFpsApp } from '@/api/fps'
import editModal from './modules/editModal'
import searchForm from './modules/searchForm'
import baseCard from '@/CrComponents/Card/Card'
import viewModal from './modules/viewModal'
export default {
  name: 'fpsAppList',
  mounted () {
    this.searchModel = { ...this.pagination }
    this.initTableData()
  },
  computed: {

  },
  components: {
    editModal,
    searchForm,
    baseCard,
    viewModal
  },
  data () {
    return {
      //card相关属性设置
      cardOption:{},
      //搜索form中的参数
      searchFormModel:{},
      // 所有搜索条件 包括分页，搜素框，表格上筛选条件
      searchModel: {},
      // 表格中的查询条件
      searchTableModel: {},
      // 高级搜索 展开/关闭
      searchInput: null,
      searchText: '',
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          this.selectedRows = selectedRows
        }
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      table: {
        data: [],
        config: {},
        columns: [{
          title: '应用名称',
          dataIndex: 'appName',
        }, {
          title: '账号',
          dataIndex: 'accountId',
        }, {
          title: '密钥',
          dataIndex: 'authToken',
        }, {
          title: 'IP地址',
          dataIndex: 'ip',
        }, {
          title: '端口',
          dataIndex: 'port',
        }, {
          title: '扫描接口',
          dataIndex: 'scanUrl',
        }, {
          title: '文件获取接口',
          dataIndex: 'getUrl',
        }, {
          title: '操作',
          fixed: 'right',
          scopedSlots:
            {
              customRender: 'actions'
            }
        }],
        searchCondition: {},
        loading: false,
        filteredInfo: null,
        sortedInfo: null
      }
    }
  },
  methods: {
    // 获取选中的table
    rowSelectChange(value){
      this.selectedRows = value
    },
    // 搜索
    setSearchCondition (searchFormModel) {
      this.searchFormModel = searchFormModel
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = { ...this.pagination, ...this.searchTableModel, ...searchFormModel }
      this.initTableData()
    },
    // 重置
    clearSearch (searchFormModel) {
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = { ...this.pagination, ...this.searchTableModel }
      this.initTableData()
    },
    // 表格中的搜索
    handleSearch (selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    // 表格中的重置
    handleReset (clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    // 初始化表格数据
    async initTableData () {
     const res = await getFpsAppList(this.searchModel).catch(err => {
        console.log('初始化失败', err)
      })
      if (res && res.status === 0) {
        this.table.loading = false
        this.table.data = res.data.list
        this.pagination.total = res.data.total
      } else {
        this.$message.warning('获取数据失败！')
      }
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.pagination.current = pagination.current
      this.searchModel = {
        ...this.searchModel,
        ...this.pagination
      }
      this.initTableData()
    },
    async deleteFn (ids) {
      const res = await deleteFpsApp({ids : ids}).catch(err => {
        console.log('初始化失败', err)
      })
      if (res && res.status === 0) {
        this.$message.success(res.info.message)
        this.initTableData()
      } else {
        this.$message.warning(res.info.message)
      }
    },
    // 删除操作
    onDelete (model) {
      this.deleteFn(model.id)
    },
    // 查看详情
    handleView (model) {
      this.$refs.viewModal.setTitle('查看预览应用接入')
      this.$refs.viewModal.setModel(model) // 先设置类型，再打开
      this.$refs.viewModal.open(true)
    },
    // 编辑
    handleEdit (model) {
      this.$refs.editModal.setTitle('编辑预览应用接入')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_MODIFY)
      this.$refs.editModal.setModel(model)// 先设置类型，再打开
      this.$refs.editModal.open(true)
    },
    // 新增
    handleAdd () {
      this.$refs.editModal.setTitle('新增预览应用接入')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_ADD)// 先设置类型，再打开
      this.$refs.editModal.open(true)
    },
    // 批量删除
    async batchDel () {
      const searchModel = this.selectedRows
      if (!searchModel || searchModel.length === 0) {
        this.$message.warning('请至少选择一行数据进行删除！')
        return
      }
      let params = ''
      searchModel.map(item => {
        params += item.id + ','
      })
      params = params.substring(0, params.length - 1)
      this.deleteFn(params)
    }
  }
}
</script>

<style scoped  lang="less">
.listContent {
  .table {
    margin-top: 10px;
  }
}
</style>